var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"kt_scrolltop",staticClass:"scrolltop",attrs:{"id":"kt_scrolltop"}},[_c('ArrowUp',{staticClass:"text-white",attrs:{"size":20}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }